import PropTypes from 'prop-types';
import React from 'react';
import {withTranslation} from 'react-i18next';
//import {i18next} from 'i18n.js';
import BaseDialogContainer from '../baseContainers/BaseDialogContainer';
import {ActionButton} from '../components/ActionButton';
import DivContainer from '../components/DivContainer';
import InputPasswordComponent from '../components/inputs/InputPasswordComponent';
import ProfileService from '../services/ProfileService';
import SettingService from '../services/SettingService';
import SimpleReactValidator from '../components/validator';
class ChangePasswordDialog extends BaseDialogContainer {
    constructor(props) {
        super(props, new ProfileService());
        this.state = {
            newPassword: '',
            repeatPassword: '',
            maxLength: 16,
            minLength: 8,
            lowerCaseCount: 1,
            upperCaseCount: 1,
            numbersCount: 0,
            specialCharactersCount: 0,
            showValidationMessage: false,
            validatePasswords: false,
        };
        this.userAgreementMapId = this.authService.getProfile().userAgreementMapId;
        this.validator = new SimpleReactValidator({}, props.t);
        this.handlePasswordsMatch = this.handlePasswordsMatch.bind(this);
    }

    translate(key) {
        const {t} = this.props;
        return t(key);
    }

    initBeforeSetElement() {
        const settingService = new SettingService();
        settingService
            .getPasswordParamsPublic()
            .then((resp) => {
                this.setState(
                    {
                        maxLength: resp['PASSWORD_MAX_LENGTH'],
                        minLength: resp['PASSWORD_MIN_LENGTH'],
                        lowerCaseCount: resp['PASSWORD_LOWERCASE_COUNT'],
                        upperCaseCount: resp['PASSWORD_UPPERCASE_COUNT'],
                        numbersCount: resp['PASSWORD_NUMBERS_COUNT'],
                        specialCharactersCount: resp['PASSWORD_SPECIAL_CHARS_COUNT'],
                    },
                    () => this.unblockUi()
                );
            })
            .catch((err) => this.unblockUi());
    }

    prepareFooter() {
        const {t} = this.props;
        return (
            <div className='footer-dialog-button-container'>
                <ActionButton label={t('details.cancel')} variant={'button cancel-button white'} handleClick={this.props.onHide} />
                <ActionButton
                    label={t('profile.changePasswordButton')}
                    variant='button save-button blue'
                    handleClick={this.handleFormSubmit}
                />
            </div>
        );
    }

    renderHeader() {
        const {t} = this.props;
        return (
            <DivContainer colClass='col-12 transaction-dialog-header'>
                <DivContainer colClass='col-12'>
                    <label>{t('profile.changePasswordButton')}</label>
                </DivContainer>
            </DivContainer>
        );
    }

    setElement() {
        this.initAfterSetElement();
    }

    createOrUpdate() {
        this.scrollToTop();
        if (this._isMounted) {
            this.blockUi();

            this.service
                .changePassword({userAgreementMapId: this.userAgreementMapId, oldPassword: this.state.oldPassword, newPassword: this.state.newPassword})
                .then((response) => {
                    // this.blockUi();
                    if (this.props.handleSuccess) {
                        this.unblockUi();
                        this.props.handleSuccess(response);
                    }
                })
                .catch((err) => {
                    if (this.props.handleError) {
                        this.unblockUi();
                        this.props.handleError(err);
                    }
                });
        }
    }

    // handleChange(e) {
    //     this.setState({
    //         [e.target.name]: e.target.value,
    //     });
    // }

    handleFormSubmit(event) {
        if (event !== undefined) {
            event.preventDefault();
        }
        if (this.validator.allValid() && this.handlePasswordsMatch()) {
            this.blockUi(this.handleValidForm);
        } else {
            this.validator.showMessages();
            // rerender to show messages for the first time
            this.scrollToError = true;
            this.setState({
                validatePasswords: true,
            });
            this.forceUpdate();
        }
    }

    handlePasswordsMatch() {
        const {newPassword, repeatPassword} = this.state;
        if (newPassword.length > 0 && repeatPassword.length > 0 && newPassword !== repeatPassword) {
            this.setState({showValidationMessage: true});
            return false;
        } else {
            this.setState({showValidationMessage: false});
            return true;
        }
    }

    renderDetails() {
        const {t} = this.props;
        return (
            <React.Fragment>
                <div className='row'>
                    <InputPasswordComponent
                        id='oldPassword'
                        // eslint-disable-next-line max-len
                        label={t('password.oldPassword')}
                        name='oldPassword'
                        value={this.state.oldPassword}
                        validator={this.validator}
                        onChange={this.handleChange}
                        viewMode='EDIT'
                        validators='required'
                        colClass='col-12 '
                        feedback={false}
                        stateField=''
                    />
                    <DivContainer colClass='col-12'>
                        <hr id='line-separator' className='line-separator password-separator' />
                    </DivContainer>
                    <InputPasswordComponent
                        id='newPassword'
                        // eslint-disable-next-line max-len
                        label={t('password.newPassword')}
                        name='newPassword'
                        value={this.state.newPassword}
                        validator={this.validator}
                        onChange={this.handleChange}
                        viewMode='EDIT'
                        validators={`required|extended_password:${this.state.minLength}:${this.state.maxLength}:${this.state.lowerCaseCount}:${this.state.upperCaseCount}:${this.state.numbersCount}:${this.state.specialCharactersCount}`}
                        colClass='col-12 '
                        stateField=''
                        onAfterStateChange={this.handlePasswordsMatch}
                    />
                </div>
                <div className='row margin-top-bottom-40'>
                    <InputPasswordComponent
                        id='repeatPassword'
                        label={t('password.repeatNewPassword')}
                        name='repeatPassword'
                        value={this.state.repeatPassword}
                        validator={this.validator}
                        onChange={this.handleChange}
                        viewMode='EDIT'
                        validators={`required`}
                        colClass='col-12'
                        stateField=''
                        feedback={false}
                        onAfterStateChange={this.handlePasswordsMatch}
                    />
                    {this.state.validatePasswords && this.state.showValidationMessage === true ? (
                        <div className='srv-validation-message' id={`${'id'}-error`}>
                            {t('validator.equals')
                                .replace(':fieldName', t('password.repeatNewPassword'))
                                .replace(':attribute', t('password.newPassword'))}
                        </div>
                    ) : null}
                </div>
            </React.Fragment>
        );
    }
}

ChangePasswordDialog.defaultProps = {
    currentUser: undefined,
    viewMode: 'EDIT',
    visible: false,
};

ChangePasswordDialog.propTypes = {
    viewMode: PropTypes.string,
    visible: PropTypes.bool,
    onHide: PropTypes.func,
    handleSuccess: PropTypes.func,
    handleError: PropTypes.func,
};

export default withTranslation()(ChangePasswordDialog);
